export default {
	data() {
		return {
			componentID: 0,
		};
	},
	created() {
		// this.$store.commit("incrementID");
		// this.componentID = this.$store.state.componentIDs.nextID;
	},
};



// WEBPACK FOOTER //
// ./src/mixins/component-ids.js